import { Injectable } from "@angular/core";
import { IShellPopoverLink, IShellPopoverLinkItem } from "@common/shell/shell-popover-link-item/shell-popover-link-item";
import { ResponsiveService } from "@common/ux/responsive/responsive.service";
import { OrganisationService } from "@org-common/lib/organisation/organisation.service";
import { combineLatest, Observable, switchMap } from "rxjs";
import { map } from "rxjs/operators";
import { coachChatPageRoute } from "../coach-chat-page/coach-chat-page.component";
import { ApplicationBarCoachChatItemComponent } from "./application-bar-coach-chat-item.component";

@Injectable()
export class ApplicationBarCoachChatItem implements IShellPopoverLinkItem {
    public readonly link: IShellPopoverLink;
    public readonly linkContent = {
        component: ApplicationBarCoachChatItemComponent,
    };
    // just before the user item
    public readonly ordinal = 998;
    public readonly isShown$: Observable<boolean>;
    public readonly isInternal = true;

    public constructor(
        responsiveService: ResponsiveService,
        orgService: OrganisationService,
    ) {
        this.link = {
            href$: orgService.currentOrganisation$.pipe(
                switchMap(() => coachChatPageRoute.getRoute()),
            ),
            openInNewTab: false,
        };

        this.isShown$ = combineLatest([
            responsiveService.currentBreakpoint$,
            orgService.currentOrganisation$,
        ]).pipe(
            map(([b, currentOrg]) => b.isDesktopSize && !!currentOrg),
        );
    }
}
